import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InGameGuard } from './in-game.guard';
import { OffGameGuard } from './off-game.guard';
import { CodeGameComponent } from './pages/code-game/code-game.component';
import { DoorEditorComponent } from './pages/door-editor/door-editor.component';
import { LevelSelectorComponent } from './pages/level-selector/level-selector.component';
import { MainMenuComponent } from './pages/main-menu/main-menu.component';
import { MyDoorsComponent } from './pages/my-doors/my-doors.component';
import { TitleScreenComponent } from './pages/title-screen/title-screen.component';


const routes: Routes = [
  { path: '', component: TitleScreenComponent, canActivate: [OffGameGuard] },
  { path: 'main-menu', component: MainMenuComponent, canActivate: [InGameGuard] },
  { path: 'code-game', component: CodeGameComponent, canActivate: [InGameGuard] },
  { path: 'level-selector', component: LevelSelectorComponent, canActivate: [InGameGuard] },
  { path: 'my-doors', component: MyDoorsComponent, canActivate: [InGameGuard] },
  { path: 'door/edit', component: DoorEditorComponent, canActivate: [InGameGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
